<template>
  <div class="container-fluid">
    <panel Title="ثبت مشخصات صاحب امضا" Des="لطفا مشخصات خریداری کننده سفته را با دقت وارد کنید." :IsBtnBack="false" ClassCustom="bg-dark-Custom text-right mt-2"></panel>

    <div v-if="ErrorList.length > 0" class="row">
      <div class="alert col-12">
        <ul>
          <li v-for="(item, key) in ErrorList" :key="key">
            {{ item.message }}
          </li>
        </ul>
      </div>
    </div>
    <div id="IntroduceSignature" class="row mt-3">
      <loading v-if="loadingRender"></loading>
      <div class="col-md-3 col-12 my-1">
        <label for="fa_first_name">نام</label>
        <input v-model="DataAxiosAdd.fa_first_name" @keypress="$ValidPersian($event, 45)" type="text" id="fa_first_name" class="required form-control" />
      </div>
      <div class="col-md-3 col-12 my-1">
        <label for="fa_last_name">نام خانوادگی</label>
        <input v-model="DataAxiosAdd.fa_last_name" @keypress="$ValidPersian($event, 45)" type="text" id="fa_last_name" class="required form-control" />
      </div>
      <div class="col-md-3 col-12 my-1">
        <label for="father_name">نام پدر</label>
        <input v-model="DataAxiosAdd.father_name" @keypress="$ValidPersian($event, 45)" type="text" id="father_name" class="required form-control" />
      </div>
      <div class="col-md-3 col-12 my-1">
        <label for="national_code">کد ملی</label>
        <input v-model="DataAxiosAdd.national_code" @keypress="$ValidNumber($event, 10)" type="text" id="national_code" class="required form-control text-left" dir="ltr" />
      </div>

      <div class="col-md-3 col-12 my-1">
        <label for="en_last_name">نام لاتین</label>
        <input v-model="DataAxiosAdd.en_last_name" @keypress="$Validengilsh($event, 50)" type="text" id="en_last_name" class="required form-control text-left" dir="ltr" />
      </div>
      <div class="col-md-3 col-12 my-1">
        <label for="en_first_name">نام خانوادگی لاتین</label>
        <input v-model="DataAxiosAdd.en_first_name" @keypress="$Validengilsh($event, 50)" type="text" id="en_first_name" class="required form-control text-left" dir="ltr" />
      </div>
      <div class="col-md-3 col-12 my-1">
        <label for="email">ادرس ایمیل</label>
        <input v-model="DataAxiosAdd.email" type="email" @keypress="$Validengilsh($event, 150)" id="email" class="required form-control text-left" dir="ltr" />
      </div>
      <div class="col-md-3 col-12 my-1">
        <label for=" birth_date">تاریخ تولد</label>
        <date-picker :editable="true" :auto-submit="true" :max="TarikhTa" color="rgb(94 163 30)" v-model="DataAxiosAdd.birth_date" :disabled="Dahgardesh"> </date-picker>
        <input type="text" tabindex="-1" id="birth_date" class="d-none InputText" style="direction: ltr" />
      </div>
      <div class="col-md-6 col-12 my-1">
        <label for="address">آدرس </label>
        <input v-model="DataAxiosAdd.address" @keypress="$ValidPersian($event, 45)" type="address" id="address" class="required form-control" />
      </div>
      <div class="col-md-3 col-12 my-1">
        <label for="postal_code"> کد پستی</label>
        <input v-model="DataAxiosAdd.postal_code" @keypress="$ValidNumber($event, 11)" type="postal_code" id="postal_code" class="required form-control text-left" dir="ltr" />
      </div>
      <div class="col-md-3 col-12 my-1">
        <label for="job_title">شغل</label>
        <input v-model="DataAxiosAdd.job_title" @keypress="$ValidPersian($event, 45)" type="text" id="job_title" class="required form-control" />
      </div>

      <div class="col-md-3 col-12 my-1">
        <label for="phone_number">شماره ثابت</label>
        <input v-model="DataAxiosAdd.phone_number" @keypress="$ValidNumber($event, 11)" type="text" id="phone_number" class="required form-control text-left" dir="ltr" />
      </div>
      <div class="col-md-3 col-12 my-1">
        <label for="mobile_number">شماره همراه</label>
        <input v-model="DataAxiosAdd.mobile_number" @keypress="$ValidNumber($event, 11)" type="text" id="mobile_number" class="required form-control text-left" dir="ltr" />
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-9 col-12"></div>
      <div class="col-md-3 col-12">
        <button @click="InsertIntroduceRequest" class="btn btn-success w-100">ثبت مشخصات صاحب امضا</button>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from '../../Tools/NetPa/Loading.vue'
import Panel from '../../Tools/NetPa/Panel.vue'
export default {
  components: { Panel, Loading },
  data() {
    return {
      loadingRender: false,
      ErrorList: [],
      DataAxiosAdd: {
        BnpInfo: {
          CustCode: this.$session.get('CustCode'),
          BnpToken: this.$session.get('TokenNetPa'),
          LoginCodeMelli: this.$session.get('CustCode').codeMeli,
        },
        is_organizational_person: false,
        address: '',
        birth_date: '',
        city_code: 302,
        email: '',
        en_first_name: '',
        en_last_name: '',
        fa_first_name: '',
        fa_last_name: '',
        father_name: '',
        gender: 1,
        job_title: '',
        mobile_number: '',
        national_code: '',
        phone_number: '',
        postal_code: '',
        state_code: 21,
        organization: null,
      },
    }
  },
  methods: {
    InsertIntroduceRequest() {
      if (this.$ValidForm('IntroduceSignature')) {
        this.loadingRender = true
        var DataAxios = { Method: 'POST', Action: 'ElectronicSafte/IntroduceSign', ArryfildValue: this.DataAxiosAdd }
        this.$PostData(DataAxios)
          .then((result) => {
            if (result.status == 'success') {
              this.loadingRender = false
              this.$mySweetDefaultTost('ثبت موفق اطلاعات', 'پیامکی حاوی رمز عبور برای شما ارسال شد', 'success', 2500)
              this.$emit('introduce_success', result.data)
            } else {
              this.loadingRender = false
              this.ErrorList = result.data
            }
          })
          .catch((error) => {
            this.loadingRender = false
            this.ErrorList = [{ message: 'مشکل ناشناخته دوباره تلاش کنید' }]
          })
      }
    },
  },
  created() {},
}
</script>
